import { useCallback, useEffect, useState } from "react";
import ImageManipulatorView, { ChosenPicture } from "./image.manipulator.view";
import * as ExpoImagePicker from "expo-image-picker";

export type ImagePickerProps = {
  isOpened: boolean;
  isCamera: boolean;
  onClose: (image?: ChosenPicture) => void;
  type: "avatar" | "background" | string;
};

export function ImagePicker(props: ImagePickerProps) {
  const [imagePickerUri, setImagePickerUri] = useState<string | null>(null);

  const fromLibrary = useCallback(async () => {
    return ExpoImagePicker.launchImageLibraryAsync({
      mediaTypes: ["images"],
      allowsEditing: false,
    });
  }, []);

  const fromCamera = useCallback(async () => {
    const status = await ExpoImagePicker.requestCameraPermissionsAsync();

    if (status.granted) {
      return ExpoImagePicker.launchCameraAsync({
        mediaTypes: ["images"],
        allowsEditing: true,
      });
    }
  }, []);

  const pickImage = useCallback(async () => {
    const result = await (async () => {
      if (props.isCamera) {
        const res = await fromCamera();

        if (res) {
          return res;
        }
      }

      return fromLibrary();
    })();

    if (!result.canceled) {
      setImagePickerUri(result.assets[0].uri);
    } else {
      props.onClose();
    }
  }, [props.type]);

  useEffect(() => {
    if (props.isOpened) {
      pickImage();
    }
  }, [pickImage, props.isOpened]);

  return (
    imagePickerUri && (
      <ImageManipulatorView
        photo={{ uri: imagePickerUri }}
        isVisible={props.isOpened}
        onPictureChoosed={props.onClose}
        onToggleModal={() => props.onClose()}
      />
    )
  );
}
